<template>
    <div class="event-info flex flex-col gap-1">
        <div
            v-if="item.eventValidFrom"
            class="event-info__date flex items-center gap-2 date-text"
        >
            <IconCalendar
                class="event-info__date__icon"
                :custom-color="buttonColor"
            />
            <div class="event-info__date__range text-sm flex flex-wrap">
                <span>{{ getDate(item.eventValidFrom) }}</span>
                <span v-if="item.eventValidTo">
                    {{ `&nbsp;- ${getDate(item.eventValidTo)}` }}
                </span>
            </div>
        </div>
        <div
            v-if="item?.eventPlace"
            class="event-info__place flex items-center gap-2"
        >
            <IconPlace
                class="event-info__place__icon"
                :custom-color="buttonColor"
            />
            <span class="event-info__place__text text-sm">{{ item.eventPlace }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import moment from 'moment';
    import IconCalendar from '~/components/icons/IconCalendar.vue';
    import IconPlace from '~/components/icons/IconPlace.vue';
    import type { ITimelineItem } from '~/types/types';
    import { useAccountStore } from '~/stores/accountStore';
    import { useI18n } from 'vue-i18n';

    defineProps<{ item: ITimelineItem }>();

    const { buttonColor } = useAccountStore().state;

    const { t } = useI18n();
    const getDate = (date: string) => {
        const momentDate = moment(date);
        if (momentDate.hours() === 0 && momentDate.minutes() === 0) {
            return moment(date).format(t('eventCalendar.event_date_format'));
        }
        return moment(date).format(t('eventCalendar.event_date_time_format'));
    };
</script>

<style lang="scss" scoped>
.event-info {
  &__date__range, &__place__text {
    color: v-bind(buttonColor)
  }
  &__date__icon, &__place__icon {
    width: 14px;
    height: 14px;
    min-width: 14px;
  }
}
</style>
